import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from './contacts.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { Contact } from '../../../interfaces/contact';
import { ContactModel } from '../../../models/contact';
import { AuthService } from '../../../services/auth.service';
import { SharedPanelService } from '../../../../dms/layout/shared-panel/shared-panel.service';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})

@AutoUnsubscribe()
export class ContactsComponent implements OnInit {
  placeholderPhone: string;
  placeholderPhoneError: string;
  placeholderEmail: string;
  placeholderName2: string;
  placeholderLastName1: string;
  clientContacts: Contact[] = [];
  copyclientContacts: Contact[] = [];
  disableAdd: boolean;
  @Input() formMode: boolean;
  @Input() modoEdicion: boolean;
  botonAnadir: boolean;
  botonNuevo: boolean;
  botonModificar: boolean;
  botonGuardar: boolean;
  botonEliminar: boolean;
  editedContact: ContactModel;
  contactSelected: ContactModel;
  elementoSeleccionado = false;
  selectedIndex: number;
  public gridData: any[];
  public formGroup: FormGroup;
  editandoLevel = false;
  elementoNuevo = false;
  pais: string;
  isLight: Subscription;
  activarLamparita: boolean;
  textObligado: string;
  textErroneo: string;
  @Input() customerId;
  deshabilitarCampos: boolean;
  constructor(
    private _authService: AuthService,
    public _sharedPanelService: SharedPanelService,
    private _contactService: ContactService,
    public _gestionTercerosService: GestionTercerosService,
    private _translateService: TranslateService,
    private toastr: ToastrService) {
    this.placeholderPhone = '';
    this.placeholderPhoneError = '';
    this.placeholderEmail = '';
    this.placeholderName2 = '';
    this.placeholderLastName1 = '';

    this.botonModificar = false;
    this.botonGuardar = false;
    this.botonEliminar = false;
  }

  ngOnInit() {
    if (this.formMode || !this.modoEdicion) {
      this.deshabilitarCampos = true;
    } else {
      this.deshabilitarCampos = false;
    }
    this.iniciarDatosTabla();
    this.disableAdd = true;
    this.pais = this._authService.getDataPais();
    this.isLight = this._sharedPanelService.observerisSwitchedOn().subscribe(val => {
      this.activarLamparita = val;
    });
    this._translateService.get('errors.required.campoObligatorio').subscribe(text => {
      this.textObligado = text;
    });
    this._translateService.get('errors.required.formatoErroneo').subscribe(text => {
      this.textErroneo = text;
    });



    this.formGroup = new FormGroup({
      CONTACTCODE: new FormControl(this.getRandomArbitrary(20, 100)),
      CUSTOMERCODE: new FormControl(this.customerId),

      Name1: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
      Name2: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [Validators.required, Validators.minLength(3)]),
      LastName1: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [Validators.required, Validators.minLength(3)]),
      LastName2: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
      Post: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
      Phone: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [Validators.required, Validators.minLength(9)]),
      Fax: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
      Email: new FormControl({ value: '', disabled: this.deshabilitarCampos }, [Validators.email]),
      Webpage: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
      Notes: new FormControl({ value: '', disabled: this.deshabilitarCampos }),
    });

  }

  get f() { return this.formGroup.controls; }



  iniciarDatosTabla() {
    this.botonAnadir = true;
    this.botonNuevo = false;
    // Lista de contactos Inicial de datos reales  clientContacts
    this.clientContacts = this._gestionTercerosService.customerForm.controls.contacts.get('clientContacts').value;

    //Estos son los que vamos a trabajar en la vista e ir actualizando copyclientContacts
    this.copyclientContacts = [... this.clientContacts];

    this.gridData = this.copyclientContacts;
    if (this.copyclientContacts.length > 0) {
      this.botonGuardar = true;
    } else {
      this.botonGuardar = false;
    }

    // actualizamos La lista  de contactos en el servicio LOCAL
    // EStos son los que ya tiene el usuario cuando entra
    this._contactService.setDataContents(this.copyclientContacts);
  }

  selectContact(event) {
    // rellenamos los inputs del romulario al pulsar en un row y
    // activamos el botón nuevo y quitamos el añadir
    this.botonAnadir = false;

    this.formGroup.get('CONTACTCODE').setValue(event.dataItem.CONTACTCODE, { emitEvent: false });
    this.formGroup.get('CUSTOMERCODE').setValue(event.dataItem.CUSTOMERCODE, { emitEvent: false });
    this.formGroup.get('Name1').setValue(event.dataItem.Name1, { emitEvent: false });
    this.formGroup.get('Name2').setValue(event.dataItem.Name2, { emitEvent: false });
    this.formGroup.get('LastName1').setValue(event.dataItem.LastName1, { emitEvent: false });
    this.formGroup.get('LastName2').setValue(event.dataItem.LastName2, { emitEvent: false });
    this.formGroup.get('Post').setValue(event.dataItem.Post, { emitEvent: false });
    this.formGroup.get('Phone').setValue(event.dataItem.Phone, { emitEvent: false });
    this.formGroup.get('Fax').setValue(event.dataItem.Fax, { emitEvent: false });
    this.formGroup.get('Email').setValue(event.dataItem.Email, { emitEvent: false });
    this.formGroup.get('Webpage').setValue(event.dataItem.Webpage, { emitEvent: false });
    this.formGroup.get('Notes').setValue(event.dataItem.Notes, { emitEvent: false });

    this.elementoSeleccionado = true;
    this.selectedIndex = event.rowIndex;

    this.contactSelected = new ContactModel();
    Object.assign(this.contactSelected, event.dataItem);

  }
  // CON LOS BOTONES FUERA DE LA TABLA
  anadir() {
    const actualContacto = this.formGroup.getRawValue();
    actualContacto.Name1 = actualContacto.Name2 + ' ' + actualContacto.LastName1 + ' ' + actualContacto.LastName2;

    // Se añade a la LISTA LOCAL y actualizamos el servicio local
    this.copyclientContacts.push(actualContacto);

    this._contactService.setDataContents(this.copyclientContacts);

    this.gridData = this.copyclientContacts;

    // this._translateService.get('genericos.toastr.successfulAdd').subscribe(text => {
    //   this.toastr.success(text);
    // });

    this.reset();
    //si la lista tiene elementos activamos el boton guardar
    if (this.copyclientContacts.length > 0) {
      this.botonGuardar = true;
    } else {
      this.botonGuardar = false;
    }
  }

  reset() {
    this.formGroup.reset({ emitEvent: false });
    this.formGroup.get('CONTACTCODE').setValue(this.getRandomArbitrary(20, 100), { emitEvent: false });
    this.formGroup.get('CUSTOMERCODE').setValue(this.customerId, { emitEvent: false });
    this.formGroup.get('Name1').setValue('', { emitEvent: false });
    this.formGroup.get('Name2').setValue('', { emitEvent: false });
    this.formGroup.get('LastName1').setValue('', { emitEvent: false });
    this.formGroup.get('LastName2').setValue('', { emitEvent: false });
    this.formGroup.get('Post').setValue('', { emitEvent: false });
    this.formGroup.get('Phone').setValue('', { emitEvent: false });
    this.formGroup.get('Fax').setValue('', { emitEvent: false });
    this.formGroup.get('Email').setValue('', { emitEvent: false });
    this.formGroup.get('Webpage').setValue('', { emitEvent: false });
    this.formGroup.get('Notes').setValue('', { emitEvent: false });
  }

  editarContacto() {
    const actualContacto = this.formGroup.getRawValue();
    actualContacto.Name1 = actualContacto.Name2 + ' ' + actualContacto.LastName1 + ' ' + actualContacto.LastName2;

    for (let i = 0; i < this.copyclientContacts.length; i++) {
      if (this.copyclientContacts[i].CONTACTCODE === actualContacto.CONTACTCODE) {
        this.copyclientContacts[i] = actualContacto;
      }
    }
    this._contactService.setDataContents(this.copyclientContacts);
    this.gridData = this.copyclientContacts;

    // this._translateService.get('genericos.toastr.modRegistryBar').subscribe(text => {
    //   this.toastr.success(text);
    // });
    //Despues de añadir dejamos el formulario limpio
    this.reset();
    // y deseleccionamos
    this.elementoSeleccionado = false;
    this.botonAnadir = true;
  }

  guardarContactos() {


    this._gestionTercerosService.customerForm.controls.contacts.get('clientContacts').setValue(this.copyclientContacts);
    // Al guardar actualizamos nuestra lista Del formulario principal
    this.clientContacts = this.copyclientContacts;


    this.reset();
    this.elementoSeleccionado = false;
    this._translateService.get('genericos.toastr.successfulSave').subscribe(text => {
      this.toastr.success(text);
    });
  }

  eliminarContacto() {
    // Pillamos la fila seleccionada de selectContact   this.contactSelected
    this._contactService.remove(this.contactSelected);
    this.copyclientContacts = this._contactService.getDataContents();

    this.gridData = this.copyclientContacts;
    // Despues de eliminar dejamos el formulario limpio y acualizamos los contactos en gestion-terceros.service.ts
    // this._gestionTercerosService.customerForm.get('contacts').get('clientContacts').setValue(this.copyclientContacts);

    // this._translateService.get('genericos.toastr.successfulDelete').subscribe(text => {
    //   this.toastr.success(text);
    //   const datosForm = this._gestionTercerosService.customerForm.getRawValue();
    // });


    this.reset();
    this.botonAnadir = true;

    if (this.copyclientContacts.length > 0) {
      this.botonGuardar = true;
      this.botonEliminar = true;
      this.botonModificar = true;
    } else {
      this.botonGuardar = false;
      this.botonModificar = false;
      this.botonEliminar = false;
    }
    this.elementoSeleccionado = false;
  }

  getRandomArbitrary(max, min) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  hasError(name) {
    return this.formGroup.get(name).hasError('required') && this.formGroup.get(name).touched;
  }

  hasErrorInvalid(name) {
    return this.formGroup.get(name).errors && (this.formGroup.get(name).dirty || this.formGroup.get(name).touched)
    // this.formGroup.get('Phone').status
  }
  blurElement(name) {

    if (this.formGroup.get(name).hasError('required') && this.formGroup.get(name).touched) {
      switch (name) {
        case 'Phone':
          this.placeholderPhone = this.textObligado;
          break;
        case 'Name2':
          this.placeholderName2 = this.textObligado;
          break;
        case 'LastName1':
          this.placeholderLastName1 = this.textObligado;
          break;
      }
    } else {
      this.placeholderPhone = '';
      this.placeholderName2 = '';
      this.placeholderLastName1 = '';
    }
  }

  blurElementMail(name) {
    this.placeholderEmail = '';
    if (this.formGroup.get(name).errors && (this.formGroup.get(name).dirty
      || this.formGroup.get(name).touched)) {
      switch (name) {
        case 'Email':
          this.placeholderEmail = this.textErroneo;
          break;
      }
    } else {
      this.placeholderEmail = '';
    }
  }


  blurElementError(name) {
    if (this.formGroup.get(name).invalid && this.formGroup.get(name).value !== '') {
      return true;
    } else {
      return false;
    }
  }
  comprobarErrores(name) {
    let errorObligatorio = false;
    let errorFormato = false;
    if (this.formGroup.get(name).hasError('required') && this.formGroup.get(name).touched) {
      errorObligatorio = true;
    }
    if (this.formGroup.get(name).invalid && this.formGroup.get(name).touched) {
      errorFormato = true;
    }
    if (errorObligatorio) {
      return 1;
    } else if (errorFormato) {
      return 2;
    } else {
      return 0;
    }
  }




  comprobarCampos() {
    let nombreMal = false;
    let apellidoMal = false;
    let telefonoMal = false;
    if (this.f.Name2.value === null || this.f.Name2.value === '') {
      nombreMal = true;
    } else {
      if (this.hasError('Name2') || this.hasErrorInvalid('Name2')) {
        nombreMal = true;
      } else { nombreMal = false; }

    }

    if (this.f.LastName1.value === null || this.f.LastName1.value === '') {
      apellidoMal = true;
    } else {
      if (this.hasError('LastName1') || this.hasErrorInvalid('LastName1')) {
        apellidoMal = true;
      } else { apellidoMal = false; }
    }

    if (this.f.Phone.value === null || this.f.Phone.value === '') {
      telefonoMal = true;
    } else {
      if (this.hasError('Phone') || this.hasErrorInvalid('Phone')) {
        telefonoMal = true;
      } else { telefonoMal = false; }
    }
    if (nombreMal || apellidoMal || telefonoMal) {
      return true; // si deshabilitamos
    } else { return false; }
  }

}

